module.exports = __webpack_public_path__ + "img/total-earn.90b0b411.svg";